import * as React from 'react';
import BoardMember from '../BoardMember/BoardMember';
import {
    Data,
} from '../../../data.js';

export default function Officials() {
    const data = Data();
    return (
        <div>
            {data.officials.map(member => (
                <BoardMember
                    name={member.name}
                    role={member.role}
                    image={member.image}
                    key={member.name}
                />
            ))}
        </div>
    );
}
